export default "/institutions/bv.svg";